// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-6cef79d8]:export {\n  menuBg: #393997;\n  menuText: #fff;\n  menuActiveText: #409eff;\n}\n\n/* Mixins */\n.edit-input[data-v-6cef79d8] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-6cef79d8] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n.verify-btn[data-v-6cef79d8] {\n  float: left;\n  margin-bottom: 16px;\n}", ""]);
// Exports
module.exports = exports;
